import {Component} from "preact";
import DotsHorizontalIcon from "mdi-preact/DotsHorizontalIcon";
import ToolbarButton from "../../../../common/toolbar-button";
import style from './style.scss';
import Portal from "preact-portal";
import ChatService from "../../../../../services/ChatService";
import * as trkl from "trkl";
import MessageService from "../../../../../services/MessageService";
import SimpleBadge from "../../../../common/simple-badge";

export default class SubBar extends Component {
    counter = trkl.computed(() => {
        return ChatService.badge() + MessageService.badge();
    });

    constructor() {
        super();

        this.state = {
            open: false,
            count: 0
        };
    }

    componentDidMount() {
        this.counter.subscribe(this.updateCount, true);
    }

    componentWillUnmount() {
        this.counter.unsubscribe(this.updateCount, true);
    }

    render(props, state, context) {
        const subBarClasses = [
            style.subBar,
            this.state.open ? style.open : null
        ].filter(i => i).join(' ');

        const buttonStyles = this.state.open ? {background: '#0079B8'} : {};
        const badge = () => this.state.count ? (<SimpleBadge>{this.state.count}</SimpleBadge>) : null;

        return (
            <div style={{height: '3em'}}>
                <ToolbarButton class={style.subBarButton} onClick={this.toggleAdditionalToolbar} style={buttonStyles}>
                    <svg class="mdi-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="mail-bulk" role="img"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                        <path fill="currentColor"
                              d="M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"></path>
                    </svg>
                    {badge()}
                </ToolbarButton>
                <Portal into={'#dpa-global-top-bar-additional-toolbar'} ref={ref => this._portal = ref}>
                    <div className={subBarClasses}>
                        {props.children}
                    </div>
                </Portal>
            </div>
        );
    }

    toggleAdditionalToolbar = () => {
        this.setState({open: !this.state.open});
    };

    updateCount = () => {
        this.setState({count: this.counter()})
    };
}


// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/sub-bar/index.js